import React from "react";

export const Canvas = ({ canvasRef }) => <canvas id="canvas" ref={canvasRef} />;
